<template>
  <div class="edit-form-list-item">
    <div class="history-item">
      <div class="history-item-button">
        <div class="button">
          <el-button
            :disabled="!(index > 0 && length > 1)"
            icon="el-icon-arrow-up"
            circle
            @click.stop="handleCommand('moveUp')"
          ></el-button>
        </div>
        <div class="button">
          <el-button
            :disabled="!(index + 1 != length && length > 1)"
            icon="el-icon-arrow-down"
            circle
            @click.stop="handleCommand('moveDown')"
          ></el-button>
        </div>
      </div>
      <div class="history-item-content">
        <el-form
          class="history-form"
          ref="historyItemForm"
          :model="item"
          :rules="rules"
          @submit.native.prevent
        >
          <el-form-item prop="description">
            <el-input
              class="input-lg"
              type="textarea"
              :autosize="{ minRows: 1, maxRows: 4 }"
              :placeholder="descriptionPlaceholder"
              v-model="item.description"
              ref="desc"
            ></el-input>
          </el-form-item>

          <el-form-item prop="description">
            <el-rate
              style="font-size: 2rem"
              v-model="item.skill_level"
              :colors="colors"
            >
            </el-rate>
          </el-form-item>

          <div class="errors" v-if="errors">
            <ul>
              <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
            </ul>
          </div>
          <div class="enter text-right">
            <el-button
              icon="el-icon-delete"
              @click.stop="handleCommand('delete')"
              >削除</el-button
            >
            <el-button
              icon="el-icon-check"
              @click.stop="$eventHub.$emit('deactivate-skill-item')"
              >OK</el-button
            >
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object
    },
    index: {
      type: Number
    },
    length: {
      type: Number
    },
    descriptionPlaceholder: {
      type: String
    },
    descriptionMaxLength: {
      type: Number
    },
    minYear: {
      type: [Number, String]
    },
    maxYear: {
      type: [Number, String]
    }
  },
  data: function () {
    const app = this
    const validateDescription = function (rule, value, callback) {
      if (app.$formLib.charCount(value) > app.descriptionMaxLength) {
        callback(new Error('Please input digits'))
      }
      callback()
    }
    return {
      errors: [],
      colors: ['#99A9BF', '#F7BA2A', '#FF9900'],
      rules: {
        description: [
          {
            validator: validateDescription,
            message:
              '一行におさまる文字数をオーバーしています。文章を短くするか、行を ＋ で追加して入力してください。',
            trigger: ['change', 'blur']
          }
        ]
      }
    }
  },
  computed: {},
  methods: {
    handleCommand: function (command) {
      if (command === 'addAbove') {
        this.$emit('add-skill-item', this.index)
      } else if (command === 'addBelow') {
        this.$emit('add-skill-item', this.index + 1)
      } else if (command === 'delete') {
        this.$emit('delete-skill-item', this.index)
      } else if (command === 'duplicate') {
        this.$emit('add-skill-item', this.index, this.item)
      } else if (command === 'moveUp') {
        this.$emit('move-skill-item', {
          index: this.index,
          to: 'up'
        })
      } else if (command === 'moveDown') {
        this.$emit('move-skill-item', {
          index: this.index,
          to: 'down'
        })
      }
    },
    resizeDesc: function () {
      const app = this
      this.$nextTick(function () {
        if (typeof app.$refs.desc.resizeTextarea === 'function') {
          // 表示されているか確認する
          if (app.$refs.desc.$el.offsetHeight) {
            app.$refs.desc.resizeTextarea()
          }
        }
      })
    }
  },
  beforeMount: function () {
    this.$nextTick(function () {
      // 初回読み込み時にバリデーションを動かす
      this.$refs.historyItemForm
        .validate()
        .then()
        .catch(function (e) {
          // console.error(e)
        })
    })
  },
  mounted: function () {
    // 表示されていない要素だとリサイズが走らないので、カード変更のタイミングで実行する
    this.$eventHub.$on('card-changed', this.resizeDesc)
  },
  destroyed: function () {
    this.$eventHub.$off('card-changed', this.resizeDesc)
  }
}
</script>
